import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-title',
    styleUrl: './title.component.scss',
    templateUrl: './title.component.html',
})
export class TitleComponent {
    public goToPreviousPage = output<void>();
    public readonly title = input.required<string>();
}
